import { CarouselTabs } from "../../../js/lib/components/CarouselTabs";
import { renderInShadow, unmountFromShadow } from "../../../js/lib/components/ShadowUtils";
import { TLCEventManager } from "../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../js/main/constants";
import { ApplicationData } from "../ls2pac/ApplicationData";
import { LS2PAC_Utils } from "../ls2pac/utils/Utils";
import { LandingPageUtil } from "./LandingPageUtil";
import { ListCarousel } from "./ListCarousel";
import * as React from 'react';

export class Slider {
  constructor(config) {
    //settings and data, cannot be undefined
    this.lists = config.lists;
    this.target = config.target;
    this.baseUrl = config.baseUrl;
    this.isDebugEnabled = config.isDebugEnabled;
    this.hasCaption = config.hasCaption || true;

    //settings & calculations
    this.slideTime = config.slideTime || 12000;
    //this.slideTime = 2000;
    //state
    this.current = 0; //TODO move to ListCarousel
    this.currentListIndex = 0;

    //currentPage
    this.currentBookHover;
    this.isHighlighting = false;
    this.jacketHoverTimeout;
    this.jacketOutTimeout;
    this.customIsActiveView = config.customIsActiveView;
    this.slideInterval;
    this.isAnimating = false;
    this.isPaused = false;
    this.arrowsVisible = false;
    this.isDestroyed = false;
    this.init();

    this.onResize();
    this.resizeTimeout;
    var _this = this;

    this.handleResize = () => {
      if(this.isDestroyed === true) return;
      if (this.resizeTimeout !== undefined) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        this.onResize();
        $.each(this.lists, (i, list) => {
          if (list.carouselList !== undefined) {
            list.carouselList.onResize(_this.listCarouselOptions);
          }
        });
      }, 300);
    }

    this.handleKeydown = (e) => {
      if(this.isDestroyed === true) return;
      if (this.isActiveView()) {
        if (e.keyCode == 37 /* left arrow key */) {
          this.flashArrow("prev");
          this.currentListPrevPage();
        } else if (e.keyCode == 39 /* right arrow key */) {
          this.flashArrow("next");
          this.currentListNextPage(true);
        } else if (e.keyCode == 40 /* down arrow key */) {
          this.onClickNextList();
        } else if (e.keyCode == 38 /* up arrow key */) {
          this.onClickPrevList();
        }
      }
    }

    $(window).on("resize", this.handleResize);
  }
  onResize() {
    var jacketContainer = $(".jacketContainer");
    this.listCarouselOptions = LandingPageUtil.getResizeDimensions(
      jacketContainer.width()
    );
    jacketContainer.css({
      "min-height": this.listCarouselOptions.pageHeight + "px",
    });
  }
  getList(id) {
    var returnList = null,
      listIndex;
    $.each(this.lists, function (i, list) {
      if (list.id === id) {
        returnList = list;
        listIndex = i;
        return false;
      }
    });
    return {
      index: listIndex,
      list: returnList,
    };
  }
  setResourceList(id, resourceList) {
    TLCLogger.log("SETTING RESOURCE LIST " + id);
    var listInfo = this.getList(id),
      list = listInfo.list;
    if (list.carouselList === undefined) {
      list.carouselList = this.createCarouselList(listInfo.index);
    }
    list.listItems = resourceList;
    list.carouselList.setResourceList(resourceList);
  }
  getCarouselList(listIndex) {
    if (listIndex >= this.lists.length) {
      TLCLogger.warn("listIndex out of bounds", listIndex);
    }
    var list = this.lists[listIndex];
    if (list.carouselList === undefined) {
      list.carouselList = this.createCarouselList(listIndex);
    }
    return list.carouselList;
  }
  createCarouselList(listIndex, isVisible) {
    return new ListCarousel(listIndex, this.listCarouselOptions, isVisible);
  }
  setDefaultResourceList(id, resourceList) {
    var list = this.getList(id).list,
      _this = this;

    list.listItems = resourceList;
    list.carouselList = this.createCarouselList(0, true);
    list.carouselList.setResourceList(resourceList, function () {
      if(_this.isDestroyed === true) return;
      // TODO what if zero loaded? Should we still be firing this callback?
      _this.addHandlers();
      _this.resetSlide();
    });
  }
  getCurrentCarouselList() {
    return this.lists[this.currentListIndex].carouselList;
  }
  resetSlide() {
    if(this.isDestroyed === true) return;
    var _this = this;
    clearInterval(this.slideInterval);
    this.slideInterval = setInterval(function () {
      if (_this.isActiveView()) {
        if (_this.isPaused === false) {
          _this.autoAdvance();
        }
      }
    }, this.slideTime);
  }
  nextListExists() {
    return this.lists.length > 1;
  }
  autoAdvance() {
    if (
      this.getCurrentCarouselList()?.isLastPage() &&
      this.nextListExists() === true
    ) {
      this.switchLists(this.getNextListIndex());
    } else {
      this.currentListNextPage(false);
    }
  }
  onPageAnimationComplete() {
    var _this = this;
    return function () {
      if(_this.isDestroyed === true) return;
      _this.resetSlide();
      _this.isAnimating = false;
      _this.getCurrentCarouselList().addNextPage();
    };
  }
  currentListNextPage(logAnalytic) {
    if (logAnalytic) {
      TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onClickLandingPageNext);
    }
    var currentCarouselList = this.getCurrentCarouselList();
    if (
      this.isAnimating === true ||
      currentCarouselList.isNotPageable() === true
    ) {
      return;
    }
    if (currentCarouselList.isNextEnabled() === false) {
      return;
    }
    this.isAnimating = true;
    currentCarouselList.goToNextPage(this.onPageAnimationComplete());
  }
  currentListPrevPage() {
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onClickLandingPagePrev); //for analytics
    var currentCarouselList = this.getCurrentCarouselList();
    if (
      this.isAnimating === true ||
      currentCarouselList.isNotPageable() === true
    ) {
      return;
    }
    if (currentCarouselList.isPrevEnabled() === false) {
      return;
    }
    this.isAnimating = true;
    currentCarouselList.goToPrevPage(this.onPageAnimationComplete());
  }
  getListIndex(listIndex /* optional */) {
    return listIndex || this.currentListIndex;
  }
  resetJacketHighlightFadeout(myDelay) {
    var _this = this;
    clearTimeout(this.jacketOutTimeout);
    myDelay = myDelay || 10000;
    this.jacketOutTimeout = setTimeout(function () {
      _this.isHighlighting = false;
      _this.currentBookHover = null;
      $(".jacket img").not($(_this.currentBookHover)).animate({
        opacity: "1.0",
      });
    }, myDelay);
  }

  getCaptionHTML() {
    var textToInsert = [],
      i = 0,
      caption = this.lists.length > 0 ? this.lists[0].caption : "";
    if (this.hasCaption === true) {
      textToInsert[i++] = '<div class="captionContainer">';
      if (LS2PAC_Utils.isEmptyString(caption)) {
        textToInsert[i++] = '<p class="caption" style="display:none;"></p>';
      } else {
        textToInsert[i++] = '<p class="caption">&nbsp;';
        textToInsert[i++] = caption;
        textToInsert[i++] = "&nbsp;</p>";
      }
      textToInsert[i++] = "</div>";
    }
    return textToInsert.join("");
  }
  init() {
    var i = 0,
      textToInsert = [];
    textToInsert[i++] = '<div id="CarouselNav"></div>';
    textToInsert[i++] = '<div class="sliderContainer">';
    textToInsert[i++] = this.getCaptionHTML();
    textToInsert[i++] =
      '<button class="TEMP_muiIconButton prev notForTouch" aria-label="prev"><svg xmlns="http://www.w3.org/2000/svg" height="36px" viewBox="0 0 24 24" width="36px"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"/></svg></button>'
    textToInsert[i++] =
      '<button class="TEMP_muiIconButton next notForTouch" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="36px" viewBox="0 0 24 24" width="36px"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><polygon points="6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12"/></g></svg></button>'
    textToInsert[i++] = '<div class="jacketContainer">';
    textToInsert[i++] = "</div>";
    textToInsert[i++] = "</div>";
    $(this.target).addClass("multi-carousel").append(textToInsert.join(""));

    this.renderTabs(0);
  }
  destroy() {
    this.isDestroyed = true;
    // clear timeouts and intervals
    clearTimeout(this.resizeTimeout);
    clearTimeout(this.jacketHoverTimeout);
    clearTimeout(this.jacketOutTimeout);
    clearInterval(this.slideInterval);
    // reset instance state
    this.isHighlighting = false;
    this.currentBookHover = null;
    // remove DOM and custom event handlers
    $(window).off("resize", this.handleResize);
    $(this.target).off("click tap", ".jacket");
    $(document).off("keydown", this.handleKeydown);
    if ($("html").hasClass("touch")) {
      $(".sliderContainer").swipe("destroy");
    }
    else {
      $(".sliderContainer").off("mouseenter mouseleave", ".jacket img");
      $(".sliderContainer").off("mousemove", ".jacket img");
      $(this.target).off("mousemove", ".sliderContainer");
      $(this.target).off("mouseenter mouseleave", ".sliderContainer");
      $(".sliderContainer").off("click", ".prev");
      $(".sliderContainer").off("click", ".next");
    }
    // handle destroying any child instances
    this.lists.forEach((list) => {
      if(list.carouselList) {
        list.carouselList.destroy();
      }
      list.carouselList = null;
    })
  }
  renderTabs(selectedIndex = 0) {
    if(!this.root){
      const handleChange = (newIndex) => {
        if(this.isDestroyed === true) return;
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onClickLandingPageNavItem
        );
        this.getCarouselList(newIndex);
        this.switchLists(newIndex, false);
      };
  
      this.root = renderInShadow(
        <CarouselTabs
          names={this.lists.map((list) => list.name)}
          selectedIndex={selectedIndex}
          onChange={handleChange}
        ></CarouselTabs>,
        document.querySelector("#CarouselNav"),
        ApplicationData.language
      );
    }
    
  }

  setActiveTab(listIndex) {
    // Unsure of a better way to handle this for now
    const container = document.querySelector("#CarouselNav");
    if(this.root && container){
      unmountFromShadow(this.root, container);
      this.root = null;
    }
    this.renderTabs(listIndex);
  }

  onJacketImageHover(jacketImg) {
    if(this.isDestroyed === true) return;
    var _this = this;
    if (this.currentBookHover !== jacketImg) {
      clearTimeout(this.jacketHoverTimeout);
      clearTimeout(this.jacketOutTimeout);
      this.currentBookHover = jacketImg;
      this.jacketHoverTimeout = setTimeout(function () {
        _this.isHighlighting = true;
        $(_this.currentBookHover).animate({
          opacity: "1.0",
        });
        $(".jacket img")
          .not($(_this.currentBookHover))
          .animate(
            {
              opacity: "0.3",
            },
            function () {
              _this.resetJacketHighlightFadeout();
            }
          );
      }, 300);
    } else {
      if (this.isHighlighting === true) {
        this.resetJacketHighlightFadeout();
      }
    }
  }
  getNextListIndex() {
    var nextListIndex = this.currentListIndex + 1;
    return nextListIndex === this.lists.length ? 0 : nextListIndex;
  }
  getPrevListIndex() {
    var prevListIndex = this.currentListIndex - 1;
    return prevListIndex < 0 ? this.lists.length - 1 : prevListIndex;
  }
  hideCaption(callback) {
    var captionEle = $("p.caption");
    captionEle.fadeOut("slow", function () {
      if (callback) {
        callback();
      }
    });
  }
  showCaption(callback) {
    var captionEle = $("p.caption"),
      caption = this.lists[this.currentListIndex].caption;
    if (!LS2PAC_Utils.isEmptyString(caption)) {
      captionEle.html("&nbsp;" + caption + "&nbsp;");
      captionEle.fadeIn("slow", function () {
        if (callback) {
          callback();
        }
      });
    }
  }
  changeCaption() {
    var _this = this;
    this.hideCaption(function () {
      _this.showCaption();
    });
  }
  
  changeList() {
    this.changeCaption();
    this.setActiveTab(this.currentListIndex);
  }
  selectList(selectedIndex) {
    if (this.currentListIndex !== selectedIndex) {
      this.currentListIndex = selectedIndex;
    }
  }
  isActiveView() {
    if (this.customIsActiveView === undefined) {
      return true;
    }
    return this.customIsActiveView();
  }
  onAnimationComplete(listIndex) {
    var _this = this;
    return function () {
      if(_this.isDestroyed === true) return;
      _this.selectList(listIndex);
      _this.showCaption();
      _this.isAnimating = false;
      _this.resetSlide();
    };
  }
  switchLists(listIndex, setActiveTab = true) {
    if (this.isAnimating === true || this.currentListIndex === listIndex) {
      return;
    }
    this.isAnimating = true;

    var _this = this,
      nextPage,
      prevPage;
    var currentCarouselList = this.getCurrentCarouselList();
    var nextCarouselList = this.lists[listIndex].carouselList;
    if (nextCarouselList === undefined) {
      //not sure what we'll do here yet
    }
    if(setActiveTab){
      this.setActiveTab(listIndex);
    }
    
    this.hideCaption();

    if (listIndex > this.currentListIndex) {
      //animate down
      currentCarouselList.animateDownOut();
      nextCarouselList.animateDownIn(this.onAnimationComplete(listIndex));
    } else {
      //animate up
      currentCarouselList.animateUpOut();
      nextCarouselList.animateUpIn(this.onAnimationComplete(listIndex));
    }
  }
  onClickPrevList() {
    //TODO if this.list[nextListIndex].listCarousel === undefined, createListCarousel...
    if (this.lists.length > 1) {
      var prevListIndex = this.getPrevListIndex();
      this.getCarouselList(prevListIndex);
      this.switchLists(prevListIndex);
    }
  }
  onClickNextList() {
    //TODO if this.list[nextListIndex].listCarousel === undefined, createListCarousel...
    if (this.lists.length > 1) {
      var nextListIndex = this.getNextListIndex();
      this.getCarouselList(nextListIndex);
      this.switchLists(nextListIndex);
    }
  }
  flashArrow(className, isEnabled) {
    var prevArrow = $(".sliderContainer").find("." + className),
      _this = this;
    prevArrow.fadeIn("fast", function () {
      //if not already visible
      if (_this.arrowsVisible === false) {
        prevArrow.fadeOut("slow");
      }
    });
  }
  onShowArrows() {
    //TODO check the state of prev/next
    var _this = this;
    $(".notForTouch").fadeIn(function () {
      _this.arrowsVisible = true;
      $(this).css("display", "inline-flex")
    });
  }
  onHideArrows() {
    var _this = this;
    $(".notForTouch").fadeOut(function () {
      _this.arrowsVisible = false;
    });
  }
  addHandlers() {
    var _this = this;

    $(document).on("keydown", this.handleKeydown);
    if ($("html").hasClass("touch")) {
      //TODO how will this work with the plugin?
      $(".sliderContainer").on("click tap", ".jacket", function (e) {
        if(_this.isDestroyed === true) return;
        e.stopPropagation(); // keep swipe from seeing it
        window.location.href = this.href;
      });
      
      $(".sliderContainer").swipe({
        swipeLeft: function (event) {
          if(_this.isDestroyed === true) return;
          if (_this.isActiveView()) {
            //if the orientation is 90 then its held in landscape 'right side up'
            //if its -90 then the ipad is 'upside down' so we have to flip the direction
            var direction = window.orientation > 0 ? 1 : -1;
            _this.currentListNextPage(true);
          }
        },
        swipeRight: function (event) {
          if(_this.isDestroyed === true) return;
          if (_this.isActiveView()) {
            //if the orientation is 90 then its held in landscape 'right side up'
            //if its -90 then the ipad is 'upside down' so we have to flip the direction
            var direction = window.orientation > 0 ? -1 : 1;
            _this.currentListPrevPage();
          }
        },
        allowPageScroll: "auto",
      });
    } else {
      $(".sliderContainer").on("mouseenter mouseleave", ".jacket img", function (event) {
        if(_this.isDestroyed === true) return;
        //set timeout, if still on the same jacket as the original request - execute
        if (event.type === "mouseenter") {
          _this.onJacketImageHover(event.currentTarget);
        } else {
          //we've left so prevent the fade
          clearTimeout(_this.jacketHoverTimeout);
          if (_this.isHighlighting === true) {
            //if we're currently faded in, reset the highlighting
            _this.resetJacketHighlightFadeout(300);
          }
        }
      });
      $(".sliderContainer").on(
        "mousemove",
        ".jacket img",
        function (event) {
          if(_this.isDestroyed === true) return;
          if (_this.currentBookHover === event.currentTarget) {
            _this.resetJacketHighlightFadeout();
          }
        }
      );
      $(this.target).on(
        "mousemove",
        ".sliderContainer",
        function (event) {
          if(_this.isDestroyed === true) return;
          _this.resetSlide();
        }
      );
      $(this.target).on("mouseenter mouseleave", ".sliderContainer", function (event) {
        if(_this.isDestroyed === true) return;
        if (event.type === "mouseenter") {
          _this.onShowArrows();
        } else {
          _this.onHideArrows();
        }
      });
      $(".sliderContainer").on("click", ".prev", function () {
        if(_this.isDestroyed === true) return;
        _this.currentListPrevPage();
        return false;
      });
      $(".sliderContainer").on("click", ".next", function () {
        if(_this.isDestroyed === true) return;
        _this.currentListNextPage(true);
        return false;
      });
    }
  }
}
